import { IoIosRadio } from "react-icons/io";
import { HiOutlineTag } from "react-icons/hi";
import { FiDownloadCloud } from "react-icons/fi";
import { HiQrCode } from "react-icons/hi2";
import { MdOutlinePassword } from "react-icons/md";
import { TbFingerprint } from "react-icons/tb";
import { FaQuestion } from "react-icons/fa";
import { LuScanFace, LuSmile } from "react-icons/lu";
import { PiHandArrowUp } from "react-icons/pi";

export const credentials = ['tag', 'controle', 'qrcode', 'senha', 'remoto', 'biometria'];

export const Credentials = {
	tag: { icon: HiOutlineTag, description: 'Tag' },
	controle: { icon: IoIosRadio, description: 'Controle' },
	qrcode: { icon: HiQrCode, description: 'QRCode' },
	senha: { icon: MdOutlinePassword, description: 'Senha' },
	remoto: { icon: FiDownloadCloud, description: 'Remoto' },
	de_api: { icon: FiDownloadCloud, description: 'Remoto' },
	biometria: { icon: LuScanFace, description: 'Biometria' },
	fingerprint: { icon: TbFingerprint, description: 'Digital' },
	desconhecido: { icon: FaQuestion, description: 'Desconhecida' },
	manual: { icon: PiHandArrowUp, description: 'Manual' }
}

export const CREDENTIAL_TYPE_NAMES = {
	1: "common.remoteControl",
	2: "common.password",
	3: "common.panicPassword",
	4: "common.tag",
	5: "common.idCtrlId",
	6: "common.remoteCredential",
	7: "Tag Sem Parar",
	100: 'common.manualAccess'
}

export const CREDENTIAL_TYPE_CODES = {
	"Senha": [2, 3],
	"Tag": [4],
	"Controle Remoto": [1],
	"Tag SemParar": [7],
	"Acesso manual": [100],
}

export function findCredential(event) {
	if (!event && !event.name) return null;

	const eventName = event.name?.toLowerCase();
	if (eventName.includes('panico') || eventName.includes('desconhecida')) {
		const credential = event.info.toLowerCase();
		if (!Object.keys(Credentials).includes(credential)) return "desconhecido";
		return credential;
	}
	if (eventName.indexOf('credencial') !== -1) {
		return eventName.substring(11, eventName.length)?.replace(' ', '_');
	}
	if (eventName.indexOf('manual') !== -1) {
		return 'manual';
	}
	if (eventName.includes('remoto')) {
		return "remoto";
	}
	if (Object.entries(event).find(([field, value]) => field.includes('car') && value)) {
		return "vehicle";
	}
	return null;
}